export const NatureEntrepriseEnum = Object.freeze({
  "COTRAITANT" : "Cotraitant",
  "SOUS_TRAITANT" : "Sous-traitant",
  "FOURNISSEUR" : "Fournisseur",
  "MANDATAIRE" : "Mandataire",
  "PRESTATAIRE" : "Prestataire"
});

export const RoleEnum = Object.freeze({
  "ADMINISTRATEUR" : "Administrateur",
  "CORRESPONDANT_EMPREINTE_UTILISATEUR" : "Correspondant empreinte utilisateur",
  "CORRESPONDANT_EMPREINTE_LECTURE" : "Correspondant empreinte lecture",
  "CORRESPONDANT_EMPREINTE_ADMINISTRATEUR" : "Correspondant empreinte administrateur",
  "CORRESPONDANT_EFFECTIFS_UTILISATEUR" : "Correspondant effectifs utilisateur",
  "CORRESPONDANT_EFFECTIFS_LECTURE" : "Correspondant effectifs lecture",
  "CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR" : "Correspondant effectifs administrateur",
  "CORRESPONDANT_SECURITE_UTILISATEUR" : "Correspondant sécurité utilisateur",
  "CORRESPONDANT_SECURITE_LECTURE" : "Correspondant sécurité lecture",
  "CORRESPONDANT_SECURITE_ADMINISTRATEUR" : "Correspondant sécurité administrateur",
  "CORRESPONDANT_GPEC_UTILISATEUR" : "Correspondant GPEC utilisateur",
  "CORRESPONDANT_GPEC_LECTURE" : "Correspondant GPEC lecture",
  "CORRESPONDANT_GPEC_ADMINISTRATEUR" : "Correspondant GPEC administrateur",
});

export const StatutEnum = Object.freeze({
  "VALIDE" : "À jour",
  "REFUSE": "Archivée_rejeté",
  "ATTENTE_MODIFICATION" : "Attente modification",
  "ATTENTE_SUPPRESSION" : "Attente suppression",
  "SUPPRIMEE" : "Archivée_suppr",
  "ARCHIVEE" : "Archivée_modif",
  "BROUILLON" : "Brouillon"
});

export const DureeContratEnum = Object.freeze({
  "MOINS_1_MOIS" : "Moins d'un mois",
  "DE_1_A_3_MOIS" : "De 1 à 3 mois",
  "DE_3_A_6_MOIS" : "De 3 à 6 mois",
  "DE_6_A_12_MOIS" : "De 6 mois à 1 an",
  "PLUS_12_MOIS" : "1 an et au-delà"
});

export const TypeContratEnum = Object.freeze({
  "CDI" : "CDI",
  "CDIC" : "CDIC",
  "CDD_CDDI" : "CDD / CDDI",
  "ALTERNANCE" : "Alternance",
  "INTERIM" : "Intérim",
  "INTERIM_INSERTION" : "Intérim d'insertion",
  "STAGE" : "Stage",
  "AUTRE" : "Autre"
});

export const TypologiePosteEnum = Object.freeze({
  "FONCTIONS_ETUDE" : "Fonctions d'étude",
  "FONCTIONS_SUPPORT_COMMERCIALES_ENCADREMENT" : "Fonctions support, commerciales et encadrement",
  "FONCTIONS_REALISATION_TRAVAUX" : "Fonctions de réalisation des travaux"
});

export const SecteurGeographiqueEnum = Object.freeze({
  "ARC_NORD_ET_EST" : "ARC NORD ET EST",
  "ARC_SUD_ET_OUEST" : "ARC SUD ET OUEST",
  "ARC_GLOBAL_ILE_DE_FRANCE" : "ARC GLOBAL ILE DE FRANCE",
  "HORS_ILE_DE_FRANCE" : "HORS ILE DE FRANCE",
  "EN_COURS_ATTRIBUTION": "EN COURS ATTRIBUTION"
});

export const mois = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août',' Septembre', 'Octobre', 'Novembre', 'Décembre'];

export const moisIndexe = Object.freeze({
  "1" : "Janvier",
  "2" : "Février",
  "3" : "Mars",
  "4" : "Avril",
  "5" : "Mai",
  "6" : "Juin",
  "7" : "Juillet",
  "8" : "Août",
  "9" : "Septembre",
  "10" : "Octobre",
  "11" : "Novembre",
  "12" : "Décembre",
});